// Should be used on user action
export const BUSY_HERE = 486;
// Should be used when invisible for the user.
export const TEMPORARILY_UNAVAILABLE = 480;
